import React, { useRef } from "react";
import { imageClassValues } from "../../data/constant";
import moment from "moment";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const VehicleReportCard = ({
  subscription,
  goToVehicleReport,
  scrollToSearchVin,
}) => {
  const { view } = useSelector((state) => state.authentication);
  const formattedDate = (date, format) => moment(date).format(format);
  const report = view?.lastReport;

  const getVehicleImageClass = (vehicleClass) => {
    for (const group of imageClassValues) {
      if (group.types.includes(vehicleClass)) {
        return group.value;
      }
    }
    return null;
  };
  const vehicleImageClass = getVehicleImageClass(
    view?.lastReport?.vehicleClass
  );

  if (!report || !view?.active) return null;
  return (
    <div className="col-12">
      <div className="cardContainer mb-4">
        <div className="cardContent">
          <div className="row">
            <div className="col-md-6 col-12">
              <div className="d-flex flex-row mb-4">
                <div className="carsSprite mr-3" />
                <div className="vehicleDetails p-3">
                  <p className="m-0">
                    On {formattedDate(report.searchDate, "MMM Do, YYYY")} at{" "}
                    {formattedDate(report.searchDate, "h:mm A")} you ran a
                    report for this
                  </p>
                  <p className="bld m-0">
                    {report.year} {report.make} {report.model}
                  </p>
                  <p>VIN {report.vin}</p>
                </div>
              </div>

              <div
                className={`scoreCard row text-center align-items-center mb-4`}
              >
                <div className="col-12">
                  <img
                    src={require("../../assets/images/score-logos.jpg")}
                    alt="Score Logos"
                  />
                </div>
                <div className="col-7 col-md-8">
                  <h4 className="p-0 m-0">AutoCheck Score</h4>
                  <p className="mb-0 mt-1">SIMILAR VEHICLE SCORE</p>
                  <p className="mb-0">
                    <strong>
                      {report.scoreRangeLow} - {report.scoreRangeHigh}
                    </strong>
                  </p>
                </div>
                <div className="col-5 col-md-4">
                  <div className="circle">
                    <h3>{report.score === 0 ? "NA" : report.score}</h3>
                  </div>
                </div>
              </div>

              <div className="mt-3 mb-3 d-flex flex-row align-items-center">
                {report.active && (
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      goToVehicleReport(report?.vin, report?.isOwner)
                    }
                  >
                    View the Full Report »
                  </button>
                )}
                <Link className="m-4 linkstyle" onClick={scrollToSearchVin}>
                  Run a new report »
                </Link>
              </div>
            </div>

            <div className="col-md-6 col-12">
              <div className="badges">
                {report.buybackAssurance === "THREE_YEARS" && (
                  <div>
                    <div className={`sprite spotlight-badge-3year`} />
                    <p className="mb-0">
                      <strong>
                        This {report.year} {report.make} {report.model}{" "}
                        qualifies for Buyback Protection
                      </strong>
                      <span
                        title={`This ${report.year} ${report.make} ${report.model} qualifies for Buyback Protection`}
                      >
                        <i className="fas fa-question-circle m-1"></i>
                      </span>
                    </p>
                  </div>
                )}

                {report.buybackAssurance === "ONE_YEAR" && (
                  <div>
                    <div className={`sprite spotlight-badge-icon`} />
                    <p className="mb-0">
                      <strong>
                        This {report.year} {report.make} {report.model}{" "}
                        qualifies for Buyback Protection
                      </strong>
                      <span
                        title={`This ${report.year} ${report.make} ${report.model} qualifies for Buyback Protection`}
                      >
                        <i className="fas fa-question-circle m-1"></i>
                      </span>
                    </p>
                  </div>
                )}

                {report.buybackAssurance === "NOT_ASSURED" && (
                  <div>
                    <div className={`sprite spotlight-badge-not-assured`} />
                    <p className="mb-0">
                      <strong>
                        This {report.year} {report.make} {report.model} does not
                        qualify for Buyback Protection
                      </strong>
                      <span
                        title={`This ${report.year} ${report.make} ${report.model} does not qualify for Buyback Protection`}
                      >
                        <i className="fas fa-question-circle m-1"></i>
                      </span>
                    </p>
                  </div>
                )}

                <hr className="mt-0 mb-0" />

                {report.singleOwner && !view?.active ? (
                  <div>
                    <div className={`sprite spotlight-single-owner`} />
                    <p className="mb-0">
                      Good news! Records indicate that this vehicle has had only
                      One Owner
                      <span title="The number of owners is an important consideration when considering a pre-owned vehicle for purchase, and should always be considered in combination with other important events like service history and mileage. The patented AutoCheck Score™ considers ownership along with other key factors to make it easy for you to assess the durability of a vehicle at a glance. Get the full vehicle history report to learn more.">
                        <i className="fas fa-question-circle m-1"></i>
                      </span>
                    </p>
                  </div>
                ) : (
                  !view?.active && (
                    <div>
                      <div className={`sprite spotlight-multi-owner`} />
                      <p className="mb-0">
                        Records indicate that this vehicle has had Multiple
                        Owners
                        <span title="The number of owners is an important consideration when considering a pre-owned vehicle for purchase, and should always be considered in combination with other important events like service history and mileage. The patented AutoCheck Score™ considers ownership along with other key factors to make it easy for you to assess the durability of a vehicle at a glance. Get the full vehicle history report to learn more.">
                          <i className="fas fa-question-circle m-1"></i>
                        </span>
                      </p>
                    </div>
                  )
                )}

                {report.accidentCount ? (
                  <div>
                    <div className={`sprite spotlight-car-accident`} />
                    <p className="mb-0">
                      Please be advised: Accident records were found for this
                      vehicle
                      <span title="Reported accidents may indicate minor to major damage to the vehicle. Knowing the severity of any accident is a key consideration when evaluating a pre-owned vehicle for purchase. Because some accidents go unreported, we recommend that all pre-owned vehicles be inspected prior to purchase. Get the full vehicle history report to learn more.">
                        <i className="fas fa-question-circle m-1"></i>
                      </span>
                    </p>
                  </div>
                ) : (
                  <div>
                    <div className={`sprite spotlight-no-accident`} />
                    <p className="mb-0">
                      Good news! No accident records were found for this vehicle
                      <span title="Reported accidents may indicate minor to major damage to the vehicle. Knowing the severity of any accident is a key consideration when evaluating a pre-owned vehicle for purchase. Because some accidents go unreported, we recommend that all pre-owned vehicles be inspected prior to purchase. Get the full vehicle history report to learn more.">
                        <i className="fas fa-question-circle m-1"></i>
                      </span>
                    </p>
                  </div>
                )}
                <hr className="mt-0 mb-0" />
                <div>
                  <div className="flex-column text-center">
                    <p className={`recordCount mb-0`}>{report.recordCount}</p>
                    <p className={`recordsText mb-0`}>RECORDS</p>
                  </div>
                  <div className="flex-column d-flex">
                    <p className="mb-0">Total records found for this vehicle</p>
                    {report.active && (
                      <p className="mb-0">
                        <button
                          className="linkstyle wa"
                          onClick={() =>
                            goToVehicleReport(report?.vin, report?.isOwner)
                          }
                        >
                          See the full report »
                        </button>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VehicleReportCard;
